import omit from 'lodash/omit';
import moment from 'moment';
import 'moment-timezone';
/** import third-party libraries in the section above, Sort Lines Ascending */

import flags from 'containers/flags/service';
/** import single application imports in the section above, Sort Lines Ascending */

// Construct the request payload from the draft
export function draftToPayload(draft) {
    const { dateRange, schedule, ...rest } = omit(draft, 'saveAsName');

    let start;
    if (dateRange.start) {
        start = moment
            .tz(dateRange.start, draft.timezone)
            .utc()
            .format();
    } else {
        start = undefined;
    }

    let end;
    if (dateRange.end) {
        end = moment
            .tz(dateRange.end, draft.timezone)
            .utc()
            .format();
    } else {
        end = undefined;
    }

    const payload = {
        ...rest,
        dateRange: {
            ...dateRange,
            // convert tz to UTC
            start,
            end,
        },
        schedule: {
            ...schedule,
            date: schedule.date ? moment(schedule.date).format('YYYY-MM-DDTHH:mm:ss') : null,
            time: schedule.time ? moment(schedule.time).format('YYYY-MM-DDTHH:mm:ss') : null,
        },
    };

    if (payload.campaigns.ids.length > 0) {
        payload.campaigns = {
            ...payload.campaigns,
            isEnabled: true,
        };
    }

    if (payload.reportMode === 'date') {
        payload.dateRange.isEnabled = true;
    }

    if (payload.reportMode === 'adEndDate') {
        payload.adEndDate = {
            ...payload.dateRange,
            isEnabled: true,
        };
    }

    return payload;
}

export function draftToPayloadV2(draft) {
    const { dateRange, adEndDate, campaigns, organizationFilter, schedule, ...rest } = omit(
        draft,
        'saveAsName'
    );

    let payload = {
        ...rest,
        schedule: {
            ...schedule,
            date: schedule.date ? moment(schedule.date).format('YYYY-MM-DDTHH:mm:ss') : null,
            time: schedule.time ? moment(schedule.time).format('YYYY-MM-DDTHH:mm:ss') : null,
        },
        efb_338_report_timezone_bug_fix: flags.isEnabled('efb_338_report_timezone_bug_fix'),
        efb_401_dooh_exclude_video_metrics: flags.isEnabled('efb_401_dooh_exclude_video_metrics'),
        efb_456_use_snowflake_new_reporting_fct_by_other_core:
            draft.efb_456_use_snowflake_new_reporting_fct_by_other_core === true,
    };

    payload.dateRange = {
        ...draft.dateRange,
        start: convertTZtoUTC(dateRange.start, draft.timezone),
        end: convertTZtoUTC(dateRange.end, draft.timezone),
    };

    payload.adEndDate = {
        ...draft.adEndDate,
        start: convertTZtoUTC(adEndDate.start, draft.timezone),
        end: convertTZtoUTC(adEndDate.end, draft.timezone),
    };

    payload.campaigns = { ...campaigns };
    payload.organizationFilter = { ...organizationFilter };

    const payloadWithoutReportMode = omit(payload, ['reportMode']);

    payloadWithoutReportMode.ignore_filter_by_date_range = true;

    return payloadWithoutReportMode;
}

export function draftToPayloadV4(draft) {
    const { dateRange, adEndDate, campaigns, organizationFilter, schedule, ...rest } = omit(draft, [
        'attributes',
        'datasource',
        'efb_338_report_timezone_bug_fix',
        'efb_401_dooh_exclude_video_metrics',
        'efb_456_use_snowflake_new_reporting_fct_by_other_core',
        'queryTag',
        'reportMode',
        'saveAsName',
    ]);

    return {
        ...rest,
        dateRange: {
            ...dateRange,
            start: convertTZtoUTCV4(dateRange.start, draft.timezone),
            end: convertTZtoUTCV4(dateRange.end, draft.timezone),
        },
        adEndDate: {
            ...adEndDate,
            start: convertTZtoUTCV4(adEndDate.start, draft.timezone),
            end: convertTZtoUTCV4(adEndDate.end, draft.timezone),
        },
        campaigns: { ...campaigns },
        organizationFilter: { ...organizationFilter },
        schedule: {
            ...schedule,
            date: schedule.date ? moment(schedule.date).format('YYYY-MM-DDTHH:mm:ss') : null,
            time: schedule.time ? moment(schedule.time).format('YYYY-MM-DDTHH:mm:ss') : null,
        },
    };
}

function convertTZtoUTCV4(date, timezone) {
    if (!date) {
        return;
    }

    return moment.tz(date, timezone).toISOString();
}
function convertTZtoUTC(date, timezone) {
    if (!date) {
        return;
    }

    return flags.isEnabled('efb_338_report_timezone_bug_fix')
        ? moment.tz(date, timezone).toISOString()
        : moment(date)
              .tz(timezone)
              .format('YYYY-MM-DDTHH:mm:ss');
}
